<template>
<div>
  <heading>{{$t('referrals.shareUrReferral')}}</heading>
  <p class="text">
  {{$t('referrals.shareUrReferralDesc')}}
  </p>
  <div class="referral-link">
    <div class="link-item" v-for="s in socials()" :key="s.label">
      <a @click.prevent="chooseRefLink(s)">
        <img class="is-circle" width="48" :src="s.icon" />
      </a>
    </div>
  </div>
  <text-field :label="$t('referrals.referralLink')" v-model="refGeneralLink" />
  <a :class="getCopyStyle"
    v-clipboard:copy="refGeneralLink"
    v-clipboard:success="onCopy"
    v-clipboard:error="onError">
    {{$t('referrals.copyToClipboard')}}
    <small class="copy-lbl" v-if="copied">{{this.$t('profile.copied')}}!</small>
  </a>
  <div class="line" />
  <heading>{{this.$t('jobs.jobseekerNameOrEmail')}}</heading>
  <p class="text">
  {{this.$t('jobs.addReferralTxt')}}
  </p>
  <autocomplete v-model="selections" />
  <p class="textForEnter" v-html="this.$t('jobs.enterEmail')"></p>
  <div class="selections">
    <referral-card class="jobseeker-card"
      v-for="(item, index) in selections" :key="index" :itemindex="index" :item="item" />
  </div>
</div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Heading from '@/components/general/heading'
import Autocomplete from '@/components/jobs/jobseeker-autocomplete-field'
import ReferralCard from '@/components/referrals/referral-card'
import TextField from '@/components/general/text-field'
import { socials } from '@/helpers/external-socials'

export default {
  components: { Heading, Autocomplete, ReferralCard, TextField },
  computed: {
    ...mapGetters('jobs', [
      'currentJob'
    ]),
    ...mapState('jobReferral', {
      selections: 'selected'
    }),
    ...mapState('referrals', [
      'refLink',
      'refGeneralLink'
    ]),
    jobTitle () {
      return this.currentJob.title
    },
    jobCompany () {
      return this.currentJob.companyName
    },
    jobLocation () {
      return this.currentJob.isRemoteAvailable ? 'remotely' : `in ${this.currentJob.locations.join(',')}`
    },
    getCopyStyle () {
      return this.copyToClipboardClicked ? 'copyClipboard copyClipboardClicked' : 'copyClipboard'
    }
  },
  methods: {
    ...mapActions('referrals', [
      'getLink',
      'getGeneralLink'
    ]),
    imageUrl (item) {
      if (item.id) {
        return item.profilePictureUrl || `/api/identicons/${item.id}`
      } else {
        return `/api/identicons/${item}`
      }
    },
    name (item) {
      if (item.id) {
        const firstName = item.firstName || ''
        const lastName = item.lastName || ''
        return `${firstName} ${lastName}`
      } else {
        return item
      }
    },
    locations (item) {
      if (item && item.details) { return item.details.location }
      return ''
    },
    role (item) {
      if (item.details) { return item.details.role }
      return ''
    },
    company (item) {
      return (item.details) ? item.details.company : ''
    },
    socials () {
      return socials
    },
    async chooseRefLink (item) {
      const jobId = this.$route.params.id
      let urlPrefix = item.urlPrefix
      switch (item.code) {
        case 'twitter':
          urlPrefix = `${urlPrefix}text=${this.jobCompany} are hiring a ${this.jobTitle} located based ${this.jobLocation}. Interested? The successful candidate will earn a signing bonus in cryptocurrency and a donation for a charity of your choice! Check it out here &url=`
          break
      }
      await this.getLink({ urlPrefix, jobId })
      window.open(this.refLink, '_blank')
    },
    onCopy () {
      this.copyToClipboardClicked = true
      this.copied = true
      const self = this
      setTimeout(_ => {
        self.copied = false
      }, 3000)
    },
    onError (e) {
      this.copied = false
    }
  },
  mounted () {
    const jobId = this.$route.params.id
    this.getGeneralLink({ jobId })
  },
  data () {
    return {
      copied: false,
      copyToClipboardClicked: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

p {
  margin-bottom: 1.5rem;
}

.textForEnter {
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #111111;
  margin-top: 6px;
}

.card.jobseeker-card {
  cursor: pointer;
}

.card.jobseeker-card:hover {
  background-color: $hover-background;
}

.card.jobseeker-card:not(:first-child) {
  border-top: 0;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
}

.card.jobseeker-card:not(:last-child) {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}

.selections {
  margin-top: 1.5rem;
}

.line {
  width: 100%;
  height: 1px;
  border: solid 1px #dddddd;
  margin-top: .8rem;
  margin-bottom: 1.5rem;
}

.referral-link {

  .link-item {
    width: 70px;
    height: 70px;
    display: inline-block;
  }
}

.copyClipboard {
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: #44C7F0;
  position: relative;
  top: -15px;

  .copy-lbl {
    font-size: 7px;
    padding: 2px 3.5px;
    border-radius: 2.6px;
    letter-spacing: 1px;
    position: relative;
    top: -2px;
    left: 2px;
  }
}

.copyClipboardClicked{
  color: #44C7F0;
  font-weight: bold;
  .copy-lbl{
    font-size: 9px;
    font-weight: bold;
    padding: 2px 3.5px;
    border-radius: 2.6px;
    letter-spacing: 1px;
    position: relative;
    top: -2px;
    left: 2px;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/jobs/jobs-refer-page.vue